// Registers the service worker (production only) and shows a banner when a new version is ready.
function banner(worker) {
  if (document.getElementById("pwa-update")) return;
  const b = document.createElement("div");
  b.id = "pwa-update";
  b.setAttribute("role", "status");
  b.style.cssText = "position:fixed;left:50%;bottom:16px;transform:translateX(-50%);z-index:99999;display:flex;gap:12px;align-items:center;padding:10px 14px;border-radius:10px;background:#1e3a8a;color:#fff;font:14px system-ui,sans-serif;box-shadow:0 4px 16px rgba(0,0,0,.25)";
  const t = document.createElement("span"); t.textContent = "A new version is available.";
  const go = document.createElement("button"); go.textContent = "Reload";
  go.style.cssText = "background:#fff;color:#1e3a8a;border:0;border-radius:6px;padding:4px 10px;font-weight:600;cursor:pointer";
  go.onclick = () => worker.postMessage("SKIP_WAITING");
  b.append(t, go); document.body.appendChild(b);
}

export function registerPWA() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");
      let reloading = false;
      const hadController = !!navigator.serviceWorker.controller; // first install must not reload the page
      navigator.serviceWorker.addEventListener("controllerchange", () => { if (hadController && !reloading) { reloading = true; window.location.reload(); } });
      const watch = (w) => w.addEventListener("statechange", () => { if (w.state === "installed" && navigator.serviceWorker.controller) banner(w); });
      if (reg.waiting && navigator.serviceWorker.controller) banner(reg.waiting);
      reg.addEventListener("updatefound", () => reg.installing && watch(reg.installing));
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
    } catch { /* installable without it; ignore */ }
  });
}
